import { render, staticRenderFns } from "./FooterSocial.vue?vue&type=template&id=3fb56f0a&scoped=true&"
import script from "./FooterSocial.vue?vue&type=script&lang=js&"
export * from "./FooterSocial.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocial.vue?vue&type=style&index=0&id=3fb56f0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb56f0a",
  null
  
)

export default component.exports